import { FC, useRef } from "react";
import ReactDOM from 'react-dom';
import { AnimatedWrap, Overlay } from "./style";
import { CSSTransition } from "react-transition-group";
import { mergeRefs } from "shared/helpers";
import { DrawerProps } from "shared/types/common";

export const Drawer: FC<DrawerProps> = ({
  isOpen,
  position,
  children,
  showOverlay = true,
  borderRadius = [0, 0, 0, 0],
  onClose
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const overlayRef = useRef<HTMLDivElement | null>(null);

  return ReactDOM.createPortal(
    <>
      <CSSTransition
        in={isOpen&&showOverlay}
        timeout={200}
        nodeRef={overlayRef}
        unmountOnExit
        classNames="drawer-fade"
      >
        <Overlay onClick={onClose} ref={overlayRef} />
      </CSSTransition>
      <CSSTransition
          in={isOpen}
          timeout={{ enter: 200, exit: 150 }}
          classNames="drawer-slide"
          unmountOnExit
          nodeRef={nodeRef}
      >
          <AnimatedWrap
              ref={mergeRefs(containerRef, nodeRef)}
              role="dialog"
              aria-modal="true"
              $position={position}
              $borderRadius={borderRadius}
          >
            {children}
          </AnimatedWrap>
      </CSSTransition>
    </>,
    document.body
  )
}